angular.module('filters').filter('templateNameWithType', function() {
  return function(template) {
    var type;
    type = (function() {
      switch (template.channel) {
        case 'sms':
          return 'SMS';
        case 'email':
          return 'Email';
        case 'push_notification':
          return 'Push Notification';
      }
    })();
    return `[${type}] ${template.name}`;
  };
});
